export default "__VITE_ASSET__969ba407__"